import { AfterViewChecked, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Brand } from '@planone/bau365/util-fair-data';

@Component({
  selector: 'bau365-exhibitor-section-brands',
  templateUrl: './section-brands.component.html',
  styleUrls: ['./section-brands.component.scss'],
})
export class SectionExhibitorBrandsComponent implements AfterViewChecked {
  @Input() brandsList?: Brand[];
  @Input() imageZoomed?: boolean;

  @Output() initialized: EventEmitter<ElementRef | undefined> = new EventEmitter<ElementRef | undefined>();

  @ViewChild('brands') brandsSection?: ElementRef;

  ngAfterViewChecked() {
    this.initialized.emit(this.brandsSection);
  }
}
